import { useFlippers } from "@shared/hooks";

const useIsDS4Enabled = () => {
  const [isDS4FlipperEnabled] = useFlippers("ds4_visual_lift_phoenix");

  return isDS4FlipperEnabled;
};

export { useIsDS4Enabled };
